module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/madh1-6adbf358c9c1965220cafeac2fc27aaa.jpg";